(() => {
  const itemSelector = '.collapsible-content__item';
  const toggleSelector = '.collapsible-content__toggle';
  const answerSelector = '.collapsible-content__answer';

  const setItemState = (item, isOpen) => {
    if (!item) return;
    const toggle = item.querySelector(`:scope > ${toggleSelector}`);
    const answer = item.querySelector(`:scope > ${answerSelector}`);

    item.classList.toggle('active', isOpen);
    if (toggle) toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    if (answer) {
      answer.hidden = !isOpen;
      answer.style.display = isOpen ? 'block' : 'none';
    }
  };

  const activateToggle = (toggle) => {
    const item = toggle.closest(itemSelector);
    if (!item) return;
    const container = item.closest('.collapsible-content__items');
    const willOpen = !item.classList.contains('active');

    if (willOpen && container) {
      container.querySelectorAll(`${itemSelector}.active`).forEach((sibling) => {
        if (sibling !== item) setItemState(sibling, false);
      });
    }
    setItemState(item, willOpen);
  };

  const initCollapsibleContent = (root = document) => {
    const toggles = [];
    if (root.nodeType === Node.ELEMENT_NODE && root.matches(toggleSelector)) toggles.push(root);
    if (typeof root.querySelectorAll === 'function') toggles.push(...root.querySelectorAll(toggleSelector));

    toggles.forEach((toggle) => {
      const item = toggle.closest(itemSelector);
      if (!item) return;
      setItemState(item, item.classList.contains('active'));

      if (toggle.dataset.oixAccordionBound === 'true') return;
      toggle.dataset.oixAccordionBound = 'true';

      toggle.addEventListener('click', () => activateToggle(toggle));
      toggle.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        activateToggle(toggle);
      });
    });
  };

  initCollapsibleContent();
  document.addEventListener('DOMContentLoaded', () => initCollapsibleContent());
  document.addEventListener('shopify:section:load', (event) => initCollapsibleContent(event.target));
})();
